export default __webpack_public_path__ + "static/media/rack.f44e4483.png";